import React, { useEffect, useRef } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Grid, Button, ButtonGroup } from '@mui/material';
import createToast from 'components/Toast/Toast';
import { useStyles } from './style';
import { PageContainer, InputV2, ButtonLoading, Icons } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import Services from '../Services';
import useCustomHook from './hooks';
import TreeView, { flattenTree } from "react-accessible-treeview";
import { Checkbox, useMediaQuery } from '@mui/material';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
import { TreeShimmerLoading } from './components';
import { constBreadCrumbsTitle } from 'utility';
const ACLEdit = () => {
  let treeRef = useRef();
  const methods = useForm();
  const navigate = useNavigate();
  const classes = useStyles();
  const isMobileSize = useMediaQuery('(max-width:660px)');
  const {
    submitLoading,
    setSubmitLoading,
    isloadProgress,
    setIsLoadProgress,
    isLoading, setIsLoading,
    isDisabledTree, setIsDisabledTree,
    demoLeftList, setDemoLeftList,
    selectedIds, setSelectedIds,
    actionTree, setActionTree,
    data, setData,
    treeRloading, setTreeRloading,
    copyActionTree, setCopyActionTree,
    allExpandIds, setAllExpandIds,
    expandIds, setExpandIds
  } = useCustomHook();
  const paramUrl = useParams();

  useEffect(() => {
    getDetails();
  }, []);


  useEffect(() => {
    if (submitLoading) setIsDisabledTree(true);
    else setIsDisabledTree(false);
  }, [submitLoading]);

  /**
   * ایجاد درخت سمت راست
   */
  const createTreeActions = (model, selectLists) => {
    let myActions = [];
    for (let item of model) {
      let actionObj = {
        id: item?.key,
        name: <p className={classes.parentIconActio} style={item.menu ? { fontWeight: 'bold' } : {}}>{item?.name}</p>,
        children: recuriveActionTree(item),
        title: item?.name,
        isMenu: item.menu || false,
      }
      myActions.push(actionObj)
    }
    const finalPage = {
      name: '',
      children: myActions
    }
    let f = flattenArray(myActions);
    setCopyActionTree(f);
    let branchIds = [];
    getExpandIds(myActions, branchIds);
    setAllExpandIds(branchIds)
    setActionTree(flattenTree(finalPage));
    let selectList = [];

    for (let item of flattenTree(finalPage)) {
      for (let id of selectLists) {
        if (item?.id === id) {
          selectList.push(item);
        }
      }
    }


    const convertedParentList = buildTreeArray(selectList, f);


    setDemoLeftList(convertedParentList);
  }

  const flattenArray = (array) => {
    let result = [];
    array.forEach((a) => {
      result.push(a);
      if (Array.isArray(a.children)) {
        result = result.concat(flattenArray(a.children));
      }
    });
    return result;
  };

  const getExpandIds = (list = [], expandIdList = []) => {
    for (let item of list) {
      if (item?.children && item?.children?.length > 0) {
        expandIdList.push(item.id)
        getExpandIds(item.children, expandIdList);
      }
    }
  }

  const getKeysWithPermission = (data) => {
    const keys = [];
    const recursiveSearch = (arr) => {
      arr.forEach(item => {
        if (item?.hasPermission === true) {

          keys.push(item.key);
        }
        if (item?.items && item?.items.length > 0) {
          recursiveSearch(item.items);
        }
        if (item?.actions && item?.actions.length > 0) {
          recursiveSearch(item?.actions);
        }
      });
    }
    recursiveSearch(data);
    return keys;
  }

  /**
     * سرویس دریافت نود های انتخاب شده درخت ها  
     */
  const getTree = async () => {
    setIsLoadProgress(true)
    await Services.getDetailsTree(paramUrl?.path)
      .then((res) => {
        const result = getKeysWithPermission(res?.result?.menus);
        setSelectedIds(result)

        createTreeActions(res?.result?.menus, result);
        setIsLoading(false)
        setIsLoadProgress(false)

      })
      .catch((error) => {
        setIsLoading(false)
        setIsLoadProgress(false)
      });
  };

  /**
  * سرویس دریافت توضیحات و نام گروه و کاربران 
  */
  const getDetails = async () => {
    await Services.getDetailsAclGroup(paramUrl?.path, {})
      .then((res) => {
        setData(res?.result);
        getTree()
      })
      .catch((error) => {
        setIsLoading(false)
        setIsLoadProgress(false)

      });
  };

  /**
     * این تابع بازگشتی برای ساخت درخت اکشن ها استفاده میشود
     */
  const recuriveActionTree = (item) => {
    let children = [];
    if (item?.actions) {
      for (let ation of item?.actions) {
        let obj = {
          id: ation?.key,
          title: ation?.name,
          name: <p className={classes.parentIconActio} style={ation.menu ? { fontWeight: 'bold' } : {}}> {ation?.name}</p>,
          isMenu: ation.menu || false,
        }

        children.push(obj)
      }

      if (item?.items && item?.items?.length > 0) {
        for (let item2 of item?.items) {
          let obj = {
            id: item2?.key,
            title: item2?.name,
            name: <p className={classes.parentIconActio} style={item2.menu ? { fontWeight: 'bold' } : {}}> {item2?.name}</p>,
            isMenu: item2.menu || false,
          }
          obj['children'] = recuriveActionTree(item2);
          children.push(obj);
        }
      }



    } else {
      if (item?.items && item?.items?.length > 0) {
        for (let item2 of item?.items) {
          let obj = {
            id: item2?.key,
            name: <p className={classes.parentIconActio} style={item2.menu ? { fontWeight: 'bold' } : {}}>{item2?.name}</p>,
            isMenu: item2.menu || false,
          }
          obj['children'] = recuriveActionTree(item2);
          children.push(obj);
        }
      }
    }

    for (let ch of children) {
      if (ch?.children && ch?.children?.length === 0) {
        delete ch.children;
      }
    }


    return children;
  }

  /**
  * سرویس ارسال فرم برای ویرایش 
  */
  const onSubmit = () => {
    const values = methods.getValues();
    if (selectedIds?.length === 0) {
      createToast('خطا', 'دسترسی انتخاب نشده است.', 'danger');
      return;
    }
    if (!values.title.trim()) {
      createToast('خطا', 'لطفا نام گروه را وارد نمایید', 'danger');
      return;
    }
    if (!values.description.trim()) {
      createToast('خطا', 'لطفا توضیحات را وارد نمایید.', 'danger');
      return;
    }

    setSubmitLoading(true);

    let params = {
      description: values.description,
      title: values.title,
      permissions: [...JSON.parse(JSON.stringify(selectedIds))],
    };

    Services.editAclGroup(paramUrl?.path, params)
      .then((res) => {
        createToast('موفق', 'اطلاعات با موفقیت ویرایش شد.', 'success');
        navigate('/Acl');
        setSubmitLoading(false);
      })
      .catch((error) => {
        setSubmitLoading(false);

      });
  };


  /**
     * هر نود که باز و بسته میشود این تابع کال میشود
     */
  const handleExpandNode = (props) => {

    const selectedIdsArr = props.treeState?.expandedIds;
    const { element, isSelected, treeState } = props;
    setExpandIds(Array.from(selectedIdsArr))
  }

  const handleSelectNode2 = (props) => {
    const selectedIdsArr = props.treeState?.selectedIds;
    const { element, isSelected, treeState } = props;
    if (isSelected) { // انتخاب شده
      const copyElemet = copyActionTree.find(a => a.id === element?.id)
      if (copyElemet?.children && copyElemet?.children?.length > 0) { //  انتخاب شده - فرزند دارد

        let allChildren = [];
        getChildList(element.id, allChildren);
        allChildren.length &&
          allChildren.forEach((child) => selectedIdsArr.add(child));

        const ancestors = getAncestors(element.id, []);
        ancestors.length &&
          ancestors.forEach((ancestor) => selectedIdsArr.add(ancestor));

      } else { // انتخاب شده - فرزند ندارد 
        const ancestors = getAncestors(element.id, []);
        ancestors.length &&
          ancestors.forEach((ancestor) => selectedIdsArr.add(ancestor));
      }

    } else {    // عدم انتخاب 
      const copyElemet = copyActionTree.find(a => a.id === element?.id)
      if (copyElemet?.children && copyElemet?.children?.length > 0) { //  عدم انتخاب شده - فرزند دارد
        let allChildren = [];
        getChildList(element.id, allChildren);
        allChildren.length &&
          allChildren.forEach((nodeId) => selectedIdsArr.delete(nodeId));

      } else { // عدم انتخاب - فرزند ندارد 

      }
    }


    let selectList = [];
    for (let item of actionTree) {
      for (let id of Array.from(props.treeState?.selectedIds)) {
        if (item?.id === id) {
          selectList.push(item);
        }
      }
    }
    setSelectedIds(
      Array.from(props.treeState?.selectedIds)
    );
    const convertedParentList = buildTreeArray(selectList, copyActionTree);
    setDemoLeftList(convertedParentList);
  }

  /**
    * هر چک باکس که تیک زده میشود این تابع کال میشود
    */
  const handleSelectNode = (props) => {
    const selectedIdsArr = props.treeState?.selectedIds;
    const { element, isSelected, treeState } = props;

    if (isSelected) { // تیک چک  باکس true شده
      const ancestors = getAncestors(element.id, []);
      let allChildren = [];
      getChildList(element.id, allChildren);
      allChildren.length &&
        allChildren.forEach((child) => selectedIdsArr.add(child));

      ancestors.length &&
        ancestors.forEach((ancestor) => selectedIdsArr.add(ancestor));
    } else { // تیک چک باکس برداشته شده
      const selectedChildren = getSelectedChildrens(element.id);
      selectedChildren.length &&
        selectedChildren.forEach((nodeId) => selectedIdsArr.delete(nodeId));
    }

    //========چک میکند اگه نود در لیست نود ها باشد، اگه پدرش نباشد ، پدرش رو به لیست انتخاب شده ها اضافه میکند
    let ancestorsFinal = [];
    for (let item of Array.from(props.treeState?.selectedIds)) {
      getAncestors2(item, ancestorsFinal);
    }
    const mySet2 = Array.from(new Set(ancestorsFinal));
    mySet2.forEach((val, i) => {
      val !== 0 && selectedIdsArr.add(val)
    });
    setSelectedIds(
      Array.from(props.treeState?.selectedIds)
    );

    //=====================================================

    //=============== برای ساخت درخت سمت چپ استفاده میشود - نودهای انتخاب شده رو به تابع میفرستد و درخت را میسازد
    let selectList = [];
    for (let item of actionTree) {
      for (let id of Array.from(props.treeState?.selectedIds)) {
        if (item?.id === id) {
          selectList.push(item);
        }
      }
    }
    const convertedParentList = buildTreeArray(selectList, copyActionTree);

    setDemoLeftList(convertedParentList);
    //==========================================================

  };

  /**
    * چک میکند و لیست پدر های یک نود رو برمیگرداند
    */
  const getAncestors = (nodeId, res) => {
    const node = actionTree.find((item) => item.id === nodeId);
    if (node?.parent) {
      return getAncestors(node.parent, [...res, node?.parent]);
    } else {
      return res;
    }
  };
  const getAncestors2 = (nodeId, res) => {
    const node = actionTree.find((item) => item.id === nodeId);
    if (node?.parent) {
      res.push(node?.parent)
      getAncestors2(node.parent, res);
    }
  };

  /**
   * چک میکند و لیست فرزندان یک نود را برمیگرداند
   */
  const getChildList = (nodeId, res) => {
    const node = actionTree.find((item) => item.id === nodeId);
    if (node?.children && node?.children.length > 0) {
      for (let ch of node?.children) {
        res.push(ch);
        getChildList(ch, res);
      }
    }
  };


  const getSelectedChildrens = (nodeId) => {
    const node = actionTree.find((item) => item.id === nodeId);
    if (node?.children) {
      const { children } = node;
      const selectedNodes = children.filter((value) =>
        selectedIds?.includes(value)
      );
      return selectedNodes.reduce(
        (acc, item) => [...acc, ...getSelectedChildrens(item)],
        selectedNodes
      );
    }
    return [];
  };

  /**
   * برای ساخت درخت سمت چپ استفاده میشود
   */
  const buildTreeArray = (flatArray = [], copy) => {
    let list = [];
    const copyArray = flatArray.filter(a => a.id !== 0);

    for (let item of copyArray) {
      list.push({
        id: item.id,
        name: copy.find(a => a.id === item.id).title,
        children: [],
        parentId: item.parent
      })
    }

    var map = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
      list[i].children = []; // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== "0" && node.parentId !== 0) {
        list[map[node.parentId]]?.children && list[map[node.parentId]].children.push(node);
      } else {
        roots.push(node);
      }
    }


    return roots;
  }

  /**
     * ساخت درخت سمت چپ
     */
  const CreateRecursiveHtml = (item) => {
    return (
      <>
        <div style={{ fontSize: '12px', fontWeight: copyActionTree.find(a => a?.id === item?.id)?.isMenu ? 'bold' : '', marginTop: '8px' }}>{item.children.length > 0 ? '●' : ''} {item.name} </div>
        {
          item.children && item.children.length > 0 &&
          item.children.map((val, index) => (
            <div style={{ marginRight: "32px" }}>
              {CreateRecursiveHtml(val)}
            </div>
          ))
        }
      </>
    )
  }
  /**
   * ساخت درخت سمت چپ
   */
  const CreateLeftHtml = () => {
    return (
      <Grid
        className={classes.checkboxs}
        direction="column"
        container item xs={12}
      >
        {
          demoLeftList.map((val, index) => (
            CreateRecursiveHtml(val)
          ))
        }
      </Grid>
    )
  }

  return (
    <PageContainer
      title="ویرایش دسترسی"
      breadcrumbs={constBreadCrumbsTitle.ACL_EDIT}
      loading={isLoading}
      meta={
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
          onClick={() => navigate('/ACL')}
        >
          بازگشت به مدیریت دسترسی‌ها
        </Button>
      }
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid direction="row" spacing={3} container item xs={12} md={12} lg={12}>
              <Grid direction="row" justifyContent='space-between' container item xs={12} md={12} lg={12}>
                <Grid className='right' container item xs={12} md={12} lg={6}>
                  <Grid item md={12} xs={12}>
                    <InputV2
                      fullWidth
                      errors={methods.formState.errors}
                      register={methods.register}
                      label="نام گروه دسترسی"
                      name="title"
                      rules={['required']}
                      defaultValue={data?.title}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <InputV2
                      label="توضیحات"
                      multiline
                      fullWidth
                      rows={5}
                      errors={methods.formState.errors}
                      name="description"
                      register={methods.register}
                      rules={['required']}
                      defaultValue={data?.description}
                    />
                  </Grid>
                </Grid>

              </Grid>

              <Grid direction="row" container item xs={12} md={12} lg={12}>
                <Grid item xs={12} md={12} lg={6}>
                  <h2 className={classes.titleBlock}>لیست آیتم‌های منو و عملیات </h2>
                  <Grid className={classes.rightBox} >
                    <Grid direction='column' style={{ width: '100%', height: '100%' }}>
                      <Grid direction='row' style={{ display: 'flex' }}>
                        <ButtonGroup orientation={isMobileSize ? 'vertical' : 'horizontal'} style={{ width: '100%' }} disabled={isloadProgress || isDisabledTree}>
                          <Button
                            disabled={selectedIds.length === copyActionTree.length}
                            onClick={() => {
                              setTreeRloading(true)
                              setIsLoadProgress(true)
                              setTimeout(() => {
                                const allList = actionTree.map(a => a.id).filter(a => a !== 0);
                                const allObjectList = actionTree.filter(a => a.id !== 0);
                                setSelectedIds(
                                  Array.from(allList)
                                );
                                const convertedParentList = buildTreeArray(allObjectList, copyActionTree);
                                setDemoLeftList(convertedParentList);
                                setTreeRloading(false)
                                setIsLoadProgress(false)

                              }, 500);

                            }}
                            color="primary"
                            variant='outlined'
                            className={classes.btnActions}
                          >
                            انتخاب همه
                          </Button>
                          <Button
                            disabled={!selectedIds.length}
                            onClick={() => {
                              setTreeRloading(true)
                              setIsLoadProgress(true)

                              setTimeout(() => {
                                setSelectedIds([]);
                                setDemoLeftList([]);
                                setTreeRloading(false)
                                setIsLoadProgress(false)

                              }, 500);
                            }}
                            color="primary"
                            variant='outlined'
                            className={classes.btnActions}
                          >
                            عدم انتخاب
                          </Button>
                          <Button
                            disabled={expandIds.length === allExpandIds.length}
                            onClick={() => {
                              setExpandIds(JSON.parse(JSON.stringify(allExpandIds)))
                              setTreeRloading(true)
                              setIsLoadProgress(true)

                              setTimeout(() => {
                                setTreeRloading(false)
                                setIsLoadProgress(false)

                              }, 500);
                            }}
                            color="primary"
                            variant='outlined'
                            className={classes.btnActions}
                          >
                            باز شدن همه آیتم‌ها
                          </Button>
                          <Button
                            disabled={!expandIds.length}
                            onClick={() => {
                              setTreeRloading(true)
                              setExpandIds([])
                              setIsLoadProgress(true)

                              setTimeout(() => {
                                setTreeRloading(false)
                                setIsLoadProgress(false)

                              }, 500);
                            }}
                            color="primary"
                            variant='outlined'
                            className={classes.btnActions}
                          >
                            بسته شدن همه آیتم‌ها
                          </Button>
                        </ButtonGroup>
                      </Grid>
                      {isloadProgress ? (
                        <TreeShimmerLoading />
                      ) : (
                        <>
                          {(submitLoading) && <div className={classes.loadingTreeSubmit}></div>}
                          {/* درخت سمت راست */}
                          <Grid
                            className={classes.checkbox}
                            direction="row"
                            container item xs={12}
                            style={{ marginTop: '8px' }}>
                            {
                              actionTree && !treeRloading &&
                              <TreeView
                                ref={treeRef}
                                onExpand={handleExpandNode}
                                data={actionTree}
                                aria-label="Checkbox tree"
                                multiSelect
                                propagateSelect={false}
                                propagateSelectUpwards={false}
                                togglableSelect
                                defaultSelectedIds={selectedIds}
                                defaultExpandedIds={expandIds}
                                onSelect={(e) => {
                                }}
                                onNodeSelect={(e) => {
                                  handleSelectNode2(e)
                                }}
                                nodeRenderer={({
                                  element,
                                  isBranch,
                                  isExpanded,
                                  isSelected,
                                  isHalfSelected,
                                  getNodeProps,
                                  level,
                                  handleSelect,
                                  handleExpand, treeState,
                                  posinset
                                }) => {
                                  return (
                                    <div
                                      {...getNodeProps({ onClick: handleExpand })}
                                      style={{ marginLeft: 20 * (level - 1), opacity: submitLoading ? 0.5 : 1, cursor: submitLoading ? 'not-allowed' : 'default' }}
                                    >
                                      {isBranch && <ArrowIcon isOpen={isExpanded} className={classes.expandClass} />}
                                      <CustomCheckBoxIcon
                                        isHalfSelected={isHalfSelected}
                                        isCheckd={isSelected}
                                        disabled={submitLoading}
                                        className="checkbox-icon"
                                        onClick={(e) => {
                                          handleSelect(e);
                                          e.stopPropagation();
                                        }}
                                        variant={
                                          isHalfSelected ? "some" : isSelected ? "all" : "none"
                                        }
                                      />
                                      <span className="name">{element.name}</span>
                                    </div>
                                  );
                                }}
                              />
                            }
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>

                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <h2 className={classes.titleBlock}>پیش نمایش آیتم‌های انتخاب شده </h2>
                  <Grid className={classes.leftBox} >
                    <Grid direction='column' style={{ width: '100%' }}>
                      <Grid
                        className={classes.checkbox}
                        direction="column"
                        container item xs={12}
                        style={{ marginTop: '8px', display: 'flex', flexDirection: 'column' }}>
                        {isloadProgress ? (
                          <TreeShimmerLoading />
                        ) : (
                          <CreateLeftHtml />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        </form>
      </FormProvider>
      <Grid direction="row" container item xs={12} style={{ marginTop: '36px' }}  justifyContent="flex-end">
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={submitLoading}
          disabled={submitLoading || isloadProgress}
          style={{ marginRight: '4px' }}
          name=" ویرایش "
          onClick={() => onSubmit()}
        />
      </Grid>
    </PageContainer >
  );
};
const ArrowIcon = ({ isOpen, className }) => {
  return isOpen ? <span className={className} ><Icons icon="CaretUp" color="#404040" size="20" /></span> : <span className={className} ><Icons icon="CaretDown" color="#404040" size="20" /></span>;
};


const CustomCheckBoxIcon = ({ isCheckd, disabled, variant, ...rest }) => {
  switch (variant) {
    case "all":
      return <Checkbox
        {...rest}
        checked={isCheckd}
        disabled={disabled}
        icon={<CheckBoxIcon />}
        checkedIcon={<CheckBoxIconFill />}
      />
    case "none":
      return <Checkbox
        {...rest}
        checked={false}
        disabled={disabled}

        icon={<CheckBoxIcon />}
        checkedIcon={<CheckBoxIconFill />}
      />
    case "some":
      return <Checkbox
        {...rest}
        checked={isCheckd}
        disabled={disabled}

        icon={<CheckBoxIcon />}
        checkedIcon={<CheckBoxIconFill />}
      />
    default:
      return null;
  }
};

export default ACLEdit;
